import { render, staticRenderFns } from "./lazyblock_paypal_code.vue?vue&type=template&id=c823f68a&scoped=true"
import script from "./lazyblock_paypal_code.vue?vue&type=script&lang=js"
export * from "./lazyblock_paypal_code.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_paypal_code.vue?vue&type=style&index=0&id=c823f68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c823f68a",
  null
  
)

export default component.exports